import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getValidationState } from '../store/actions/verification';

export function ImportLoading({
  getValidationState,
  importStatus,
  successMessages
}) {
  const [timer, setTimer] = useState(
    setInterval(() => getValidationState(importStatus, successMessages), 3000)
  );

  useEffect(() => {
    return () => {
      clearInterval(timer);
      setTimer(null);
    };
  }, []);

  return null;
}

ImportLoading.propTypes = {
  getValidationState: PropTypes.func.isRequired,
  importStatus: PropTypes.array.isRequired,
  successMessages: PropTypes.object.isRequired
};

const mapDispatchToProps = {
  getValidationState
};

export default connect(null, mapDispatchToProps)(ImportLoading);
